import React, { useRef, useEffect } from "react";
//import { amountToWords } from "../../../amountToWords";
import { useReactToPrint } from "react-to-print";

// npm install react-to-print

const Print_Receipt = ({ schoolDetails, headerData, feeStructData, installTotData, feeRecordData, onAfterPrint }) => {

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    //content: () => printRef.current,
    contentRef: printRef,

    pageStyle: `
    @page {
      size: 150mm 185mm;
      margin: 5mm;
    }

    @media print {
      html,
      body {
        margin: 0;
        padding: 0;
      }

      #receipt-print-area {
        box-sizing: border-box;
        width: 100%;
      }
    }
  `,

    onAfterPrint: () => {
      if (onAfterPrint) {
        onAfterPrint();
      }
    },

  });

  const showPrintReady = () => {
    return (
      schoolDetails?.schoolName &&
      feeRecordData &&
      feeRecordData.length > 0
    );
  };

  // const formatDate = (dateStr) => {
    
  //   if (!dateStr) return "";
  //   const date = new Date(dateStr);

  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
  //   const year = date.getFullYear();

  //   return `${day}/${month}/${year}`;
  // };

  const feeCard = {

    company: schoolDetails.schoolName,
    address1: schoolDetails.schoolAddr1,
    address2: schoolDetails.schoolAddr2,
    phone: schoolDetails.schoolPhone1,
    email_id: schoolDetails.email_id,
    website: schoolDetails.website,
    logo_path: schoolDetails.logoPath,
    logo_name: 'school_logo.png',
    year1: headerData.year1,
    year2: headerData.year2,
    grNo: headerData.gr_no,
    stud_name: headerData.stud_name,
    std_div: headerData.std_name || '/' || headerData.div_name,
    terms1: headerData.terms,
    studPic: headerData.stud_pic,
  };

 // const parseAmount = v => Number(String(v).replace(/,/g, "") || 0);

  const formatAmount = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "40px" }}>
      {/* <div style={{ fontFamily: "courier", padding: "20px" }}> */}
      {/* 🔹 Print button (not included in print area) */}
      <button
        onClick={handlePrint}
        style={{
          marginBottom: "20px",
          padding: "8px 16px",
          cursor: "pointer",
        }}
      >
        🖨️ Print Fee Card
      </button>

      {/* 🔹 Receipt content to be printed */}
      <div ref={printRef} id="receipt-print-area" //style={{ border: "2px solid #000", padding: "10px", borderRadius: "4px" }}
          style={{ border: "2px solid #000", padding: "8px",       // Fill printable area
                     boxSizing: "border-box", background: "#fff", }} >

        {/* HEADER */}
        <div style={{ display: "grid", gridTemplateColumns: "50px minmax(0, 1fr) 60px",
            columnGap: "6px", alignItems: "stretch", paddingBottom: "5px", width: "100%", boxSizing: "border-box", }} >
          {/* LEFT - SCHOOL LOGO */}
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start", width: "50px", }} >

            {feeCard.logo_path && (
              <img
                src={`${feeCard.logo_path}${feeCard.logo_name}`}
                alt="School Logo"
                style={{ width: "50px", height: "38px",   // approximately school name + tagline
                  objectFit: "contain", display: "block", }}
                onError={(e) => {e.target.style.display = "none";}} />
            )}
          </div>

          {/* CENTER - SCHOOL DETAILS */}
          <div style={{ textAlign: "center", minWidth: 0, overflow: "hidden", }} >
            {/* School Name */}
            <div style={{ margin: 0, fontSize: "16px", lineHeight: "18px", fontWeight: "bold", whiteSpace: "nowrap", 
                          overflow: "hidden", textOverflow: "ellipsis", }} >
              {feeCard.company}
            </div>

            {/* Tag Line */}
            <div style={{ margin: 0, fontSize: "10px", lineHeight: "12px", whiteSpace: "nowrap", }} >
              <u>Success in this world and Aakhirah</u>
            </div>

            {/* Address */}
            <div style={{ margin: "3px 0 0", fontSize: "11px", lineHeight: "13px", }} >
              {feeCard.address1}, {feeCard.address2}
            </div>

            {/* Phone / Website / Email */}
            <div style={{ margin: "2px 0 0", fontSize: "9px", lineHeight: "12px", wordBreak: "break-word", }} >
              ☎: {feeCard.phone} &nbsp; ✆: 88790 16151 &nbsp; 🌐: {feeCard.website} &nbsp; ✉: {feeCard.email_id}
            </div>
          </div>

          {/* RIGHT - STUDENT PHOTO */}
          <div style={{ width: "60px", minWidth: "60px", display: "flex", alignItems: "stretch", justifyContent: "flex-end", }} >
            {feeCard.studPic && (
              <img src={feeCard.studPic}
                alt="Student Pic"
                style={{ width: "60px", height: "100%", minHeight: "75px", objectFit: "cover", display: "block", }}
                onError={(e) => { e.target.style.display = "none"; }} />
            )}
          </div>
        </div>

        <hr style={{ border: "1px solid #000", margin: "5px 0 10px 0" }} />

        {/* ******************************************************** */}
        {/* Start : Student details */}
        {/* ******************************************************** */}

        <table style={{ width: "100%", marginTop: "10px", maxHeight: '35px', borderCollapse: "collapse", border: "none" }}>
          <tbody>
            <tr>
              <td style={{ width: "100%", padding: "3px", border: "1px solid #000", fontSize: "15px" }} colSpan={4}> 
                <strong>Student Name :</strong> {feeCard.stud_name.replace(/^\d+\s*/, "")} </td>
            </tr>
            <tr>
              <td style={{ width: "50%", padding: "3px", border: "1px solid #000", fontSize: "15px" }}>
                <strong>GR No. :</strong> {feeCard.grNo}</td>
              <td style={{ width: "50%", padding: "3px", border: "1px solid #000", fontSize: "15px" }}>
                <strong>Std / Div :</strong> {feeCard.std_div}</td>
            </tr>
          </tbody>
        </table>

        {/* ******************************************************** */}
        {/* End : Student details */}
        {/* ******************************************************** */}

        {/* ******************************************************** */}
        {/* Start : Fees Structure Table */}
        {/* ******************************************************** */}

        {/* <p style={{ marginTop: "5px", fontSize: "15px", textAlign: "center" }}>
          <strong>FEES STRUCTURE ( 
          <span> {feeCard.year1} - {feeCard.year2})</span>
          </strong>
        </p> */}

        <div style={{ marginTop: "8px", fontSize: "15px", textAlign: "center" }}>
          <strong>FEES STRUCTURE ( 
          <span> {feeCard.year1} - {feeCard.year2})</span>
          </strong>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "7px", maxHeight: '35px' }} >
          <thead>
            <tr>
              <th style={{
                width: "3%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'
              }}>Sr. #</th>

              <th style={{
                width: '40%', textAlign: 'left', border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000" }}>Description</th>
              <th style={{
                width: '12%', textAlign: 'right', border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000"
              }}>Amount (₹)</th>
            </tr>
          </thead>

          <tbody>
            {feeStructData && feeStructData.length > 0 ? (
              feeStructData.map((row, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontSize: "14px" }}> {index + 1}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px" }}>{row.fees_desc}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", textAlign: "right", fontSize: "14px" }}> 
                    {formatAmount(row.fee_amt)} 
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }} >
                  No Data Available
                </td>
              </tr>
            )}

          </tbody>
        </table>

        {/* ******************************************************** */}
        {/* End : Fees Structure Table */}
        {/* ******************************************************** */}

        {/* ******************************************************** */}
        {/* Start : Installments */}
        {/* ******************************************************** */}

        <div style={{ marginTop: "8px", fontSize: "15px", textAlign: "center" }}>
          <strong>INSTALLMENTS</strong>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "7px", maxHeight: '35px' }} >
          <thead>
            <tr>
              <th style={{
                width: "15%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>1st
              </th>
              <th style={{
                width: "15%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>2nd
              </th>
              <th style={{
                width: "15%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>3rd
              </th>
              <th style={{
                width: "15%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>4th
              </th>
              <th style={{
                width: "15%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>5th
              </th>
              <th style={{
                width: "15%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>6th
              </th>

            </tr>
          </thead>

          <tbody>
            {installTotData && installTotData.length > 0 ? (
              installTotData.map((row, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    ₹ {formatAmount(row.install1)}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    ₹ {formatAmount(row.install2)}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    ₹ {formatAmount(row.install3)}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    ₹ {formatAmount(row.install4)}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    ₹ {formatAmount(row.install5)}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    ₹ {formatAmount(row.install6)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }} >
                  No Data Available
                </td>
              </tr>
            )}

          </tbody>
        </table>

        {/* ******************************************************** */}
        {/* End : Installments */}
        {/* ******************************************************** */}
        <div style={{ marginTop: "5px", fontSize: "14px", textAlign: "left" }}>
          {feeCard.terms1}
        </div>

        {/* ******************************************************** */}
        {/* Start : Fee Records */}
        {/* ******************************************************** */}

        <div style={{ marginTop: "8px", fontSize: "15px", textAlign: "center" }}>
          <strong>FEE RECORDS</strong>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "7px", maxHeight: '35px' }} >
          <thead>
            <tr>
              <th style={{
                width: "14%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>Installments
              </th>
              <th style={{
                width: "14%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>1st
              </th>
              <th style={{
                width: "14%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>2nd
              </th>
              <th style={{
                width: "14%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>3rd
              </th>
              <th style={{
                width: "14%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>4th
              </th>
              <th style={{
                width: "14%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>5th
              </th>
              <th style={{
                width: "14%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'}}>6th
              </th>

            </tr>
          </thead>

          <tbody>
            {feeRecordData && feeRecordData.length > 0 ? (
              feeRecordData.map((row, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    <b>{row.heading}</b> </td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    {row.install1_date}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    {row.install2_date}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    {row.install3_date}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    {row.install4_date}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    {row.install5_date}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px", textAlign: "center" }}>
                    {row.install6_date}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }} >
                  No Data Available
                </td>
              </tr>
            )}

          </tbody>
        </table>

        {/* ******************************************************** */}
        {/* End : Fee Records */}
        {/* ******************************************************** */}

      </div>
    </div>
  );
};

export default Print_Receipt;
